import React, { useEffect } from "react";

/**
 * Minimal click-to-zoom lightbox. Renders a fixed overlay with the full-size image.
 * Close on backdrop click, Esc, or the × button.
 */
export default function ImageLightbox({ src, alt, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [onClose]);

  if (!src) return null;

  return (
    <div
      data-testid="image-lightbox"
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, zIndex: 1000,
        background: "rgba(15, 12, 10, 0.92)",
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: 32, cursor: "zoom-out",
      }}
    >
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        data-testid="image-lightbox-close"
        aria-label="Close"
        style={{
          position: "absolute", top: 20, right: 24,
          background: "rgba(255,255,255,0.12)", color: "#FFFBF3",
          border: "1.5px solid rgba(255,255,255,0.25)",
          borderRadius: 999, width: 40, height: 40, fontSize: 20, lineHeight: 1,
          cursor: "pointer", fontFamily: "Host Grotesk, sans-serif",
        }}
      >
        ×
      </button>
      <img
        src={src}
        alt={alt || ""}
        onClick={(e) => e.stopPropagation()}
        style={{
          maxWidth: "95vw", maxHeight: "92vh",
          objectFit: "contain", display: "block",
          borderRadius: 8, boxShadow: "0 20px 60px rgba(0,0,0,0.6)",
          cursor: "default",
        }}
      />
    </div>
  );
}
